export default __webpack_public_path__ + "static/media/case2-1 (4).c8644f88.png";